/**
 * Central export point for all auth providers and interfaces.
 * 
 * Use AUTH_PROVIDER token for dependency injection:
 * @example
 * export class MyService {
 *   private authProvider = inject(AUTH_PROVIDER);
 * }
 */

export * from './auth-provider.interface';
export * from './microsoft.service';
export * from './firebase.service';
export * from './zitadel.service';
